import { render } from "./ThemeManager.vue?vue&type=template&id=bdc38980"
import script from "./ThemeManager.vue?vue&type=script&lang=js"
export * from "./ThemeManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__